<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div
            class="backgroud-white  cs-contentContainer-right-content cs-fullHeight cs-finance-discountList-conainter">
            <el-row>
              <el-col :span="24">
                <el-row>
                  <el-col>
                    <span class="cs-title">优惠列表</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-tabs v-model="activeTab" type="card">
                      <el-tab-pane name="1">
                        <span slot="label"> 占位 </span>
                        <el-row class="grid-content">
                          <el-col>
                            <discountList :isActive="activeTab=='1'" :accountType="1" :universityList="universityList" :universityGroups="universityGroups" :termList="termList"></discountList>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                      <el-tab-pane name="2">
                        <span slot="label"> 课程报名 </span>
                        <el-row class="grid-content">
                          <el-col>
                            <discountList :isActive="activeTab=='2'" :accountType="2" :universityList="universityList" :universityGroups="universityGroups" :termList="termList"></discountList>
                          </el-col>
                        </el-row>
                      </el-tab-pane>

                      <el-tab-pane name="3">
                        <span slot="label"> 职业培训占位 </span>
                        <el-row class="grid-content">
                          <el-col>
                            <discountList :isActive="activeTab=='3'" :accountType="8" :universityGroups="universityGroups"></discountList>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                      <el-tab-pane name="4">
                        <span slot="label"> 职业培训课程报名 </span>
                        <el-row class="grid-content">
                          <el-col>
                            <discountList :isActive="activeTab=='4'" :accountType="9" :universityGroups="universityGroups"></discountList>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                      <el-tab-pane name="5">
                        <span slot="label"> 应试英语课程报名 </span>
                        <el-row class="grid-content">
                          <el-col>
                            <discountList :isActive="activeTab=='5'" :accountType="10" :universityGroups="universityGroups"></discountList>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                      <el-tab-pane name="6">
                        <span slot="label"> 新生引流课程报名 </span>
                        <el-row class="grid-content">
                          <el-col>
                            <discountList :isActive="activeTab=='6'" :accountType="18" :universityGroups="universityGroups"></discountList>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                    </el-tabs>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss">

</style>

<script>
import navigator from "../../components/navigator";
import discountList from "../../components/finance/discountList";
import { getUniversities, getUniversityGroups, getTerms } from "../../service/common.service";

export default {
  data() {
    return {
      activeTab: "1",
      universityList: [],
      universityGroups: [],
      termList: [],
    };
  },
  components: {
    navigator,
    discountList,
  },
  computed: {},
  created() {
    getUniversities().then((result) => {
      if (!!result && result.success) {
        this.universityList = result.data;
      }
    });
    // getUniversityGroups().then((result) => {
    //     if (!!result && result.success) {
    //       this.universityGroups = result.data;
    //     }
    //   });
    getTerms(true).then((result) => {
      if (!!result && result.success) {
        this.termList = result.data;
      }
    });
  },
};
</script>
 



// WEBPACK FOOTER //
// src/page/finance/discountManage.vue